// Rules for offering MANUAL_MATCH in the resolve modal.
//
// A match is made by the match door (`/difference/manual-match`), never typed:
// its member fingerprints are machine identities no human knows. The modal
// may offer the code ONLY when the selection is a pair it can route to that
// door — exactly two residuals, one from each side. Everything else keeps the
// explain vocabulary and never sees a fingerprint field.
import type { ReasonCodeSpec } from './types'
import vocab from './vocabulary.json'

// from the GENERATED vocabulary — recon_state.MATCH_CODE's one home
export const MANUAL_MATCH: string = vocab.match_code

export interface PairTargetLike {
  fingerprint: string
  /** residual side, e.g. "26AS not in books" / "Books not in 26AS" */
  side?: string
}

/** The two residual fingerprints to pair, or null when the selection is not
 *  a routable pair (wrong kind, wrong count, unknown or equal sides). */
export function residualPair(
  itemKind: 'party' | 'residual',
  targets: PairTargetLike[],
): [string, string] | null {
  if (itemKind !== 'residual' || targets.length !== 2) return null
  const [a, b] = targets
  if (!a.side || !b.side) return null
  const a26 = a.side.startsWith('26AS')
  const b26 = b.side.startsWith('26AS')
  if (a26 === b26) return null
  return [a.fingerprint, b.fingerprint]
}

/** Reason entries for the picker: MANUAL_MATCH only for a routable pair. */
export function visibleReasons(
  reasons: Record<string, ReasonCodeSpec>,
  pairable: boolean,
): [string, ReasonCodeSpec][] {
  return Object.entries(reasons).filter(([code]) => code !== MANUAL_MATCH || pairable)
}
